export default __webpack_public_path__ + "static/media/catago-logo.d86fe68c.png";